var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user != null)?_c('div',{staticClass:"solid-track-session"},[_c('i',[_c('small',[_vm._v(" SOLID : "),_c('a',{attrs:{"href":_vm.webId,"target":"_blank"}},[_vm._v(_vm._s(_vm.user))])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }